import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'logout-icon',
  templateUrl: './logout-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LogoutIconComponent {}
